import React from 'react';
import PropTypes from 'prop-types';

import i18n from '../../config/i18n';

class EmailForm extends React.Component {
  onSubmit = (e) => {
    e.preventDefault();
    return this.props.generateResetToken(this.emailInput.value);
  };

  render() {
    return (
      <form onSubmit={this.onSubmit}>
        <div className="form-group">
          <label className="control-label" htmlFor="email">
            {i18n.t('email')}
          </label>
          <input
            id="email"
            className="form-control"
            type="text"
            ref={(input) => { this.emailInput = input; }}
          />
        </div>
        <div className="form-group clearfix">
          <button className="btn btn-primary pull-right">
            {i18n.t('sendResetEmail')}
          </button>
        </div>
      </form>
    );
  }
}

EmailForm.propTypes = {
  generateResetToken: PropTypes.func.isRequired,
};

export default EmailForm;



// WEBPACK FOOTER //
// ./src/components/login/EmailForm.js